<template>
<div class="iframe-resize-container">
  <div class="iframe-content" :style="{maxWidth: maxWidth}">
    <iframe ref="iframe" :height="height" :src="attributes.value" frameborder="0" scrolling="no"></iframe>
  </div>
</div>
</template>

<script>
export default {
  props: ['attributes'],
  computed: {
    maxWidth () {
      const {maxwidth} = this.attributes
      return maxwidth || 'auto'
    },
    height () {
      const {height} = this.attributes
      return height || 'auto'
    }
  },
  mounted () {
    window.addEventListener('message', this.onMessage, false)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.onMessage)
  },
  methods: {
    onMessage (a) {
      if(void 0!==a.data["datawrapper-height"]) {
        for(var e in a.data["datawrapper-height"]){
          var t=document.getElementById("datawrapper-chart-"+e)||document.querySelector("iframe[src*='"+e+"']");t&&(t.style.height=a.data["datawrapper-height"][e]+"px")
        }
      }
    }
  }
}
</script>

<style lang="scss">
.iframe-resize-container {
  line-height: 0;

  .iframe-content {
    margin: 0 auto;

    iframe {
      width: 1px;
      min-width: 100%;
    }
  }
}
</style>
